// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.label_KWLLW {
  font-family: Lato, sans-serif;
}

.label_KWLLW.label-small_xnSSz {
  font-size: 12px;
}

.label_KWLLW.editorHeader_gYYrx {
  line-height: 36px;
  color: #565656;
  font-family: Helvetica;
  font-size: 32px;
  font-weight: bold;
  line-height: 38px;
  background: #f9f9f9;
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@leverege/ui-elements/lib/esm/theme/Label.css"],"names":[],"mappings":"AAAA;EACE,6BAA6B;AAC/B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,sBAAsB;EACtB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;AACrB","sourcesContent":[".label {\n  font-family: Lato, sans-serif;\n}\n\n.label.label-small {\n  font-size: 12px;\n}\n\n.label.editorHeader {\n  line-height: 36px;\n  color: #565656;\n  font-family: Helvetica;\n  font-size: 32px;\n  font-weight: bold;\n  line-height: 38px;\n  background: #f9f9f9;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"label": `label_KWLLW`,
	"label-small": `label-small_xnSSz`,
	"editorHeader": `editorHeader_gYYrx`
};
export default ___CSS_LOADER_EXPORT___;
